import { Box, FormControlLabel, Typography, styled } from "@mui/material";

export const Section = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: "start",
    gap: '5px',
    maxHeight: '80vh',
    overflowY: 'auto'

}))
export const TextHeader = styled(Typography)(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: '800',
    lineHeight: '20px',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary :
        theme.palette.text.darkSecondary,
    marginBottom: 'px'
}))
export const FormControlCus = styled(FormControlLabel)(({ theme }) => (props) => ({
    height: '50px',
    display: "flex",
    alignItems: 'center',
    ' & .muirtl-eiuvpx-MuiTypography-root': {
        padding: '7px',
        background: theme.palette.mode === "light" ? '#f2f2f2' : '',
        minWidth: '20px',
        textAlign: 'center',
        fontWeight: '500'
    },
}))

export const Content = styled(Box)(({ theme }) => (props) => ({
    height: '50px',
    display: "flex",
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '90%',
    borderBottom: `1px solid #e2e2e2`,
    marginTop: '15px'
}))
export const ContentMethod = styled(Box)(({ theme }) => (props) => ({
    height: '60px',
    display: "flex",
    marginTop: '15px',
    alignItems: 'center',
    justifyContent: 'start',
    width: '90%',
    borderBottom: `1px solid #e2e2e2`,
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))
